/**
 * External Dependencies
 */
import { get } from 'lodash';

export default (state) => get(state, ['graphCube', 'meta', 'meta'], {});
